module.exports = __webpack_public_path__ + "static/img/14.708bf05.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/zh/14.png
// module id = fGk2
// module chunks = 0